import SyntariLanding from './SyntariLanding';

function App() {
  return <SyntariLanding />;
}

export default App;
